import { useState } from "react";
import { syncYandexForms } from "../../../api/forms";
import { ApiError } from "../../../api/client";
import { Button } from "../../../components/ui/button";

interface YandexSyncButtonProps {
  onSynced?: () => void;
  onError?: (message: string) => void;
}

export function YandexSyncButton({ onSynced, onError }: YandexSyncButtonProps) {
  const [syncing, setSyncing] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleSync = async () => {
    setSyncing(true);
    setMessage(null);

    try {
      const result = await syncYandexForms();
      const summary = `Синхронизация: +${result.created} новых, ${result.updated} обновлено, ${result.missing} скрыто`;
      setMessage(summary);
      onSynced?.();
    } catch (err) {
      onError?.(
        err instanceof ApiError
          ? err.message
          : "Не удалось синхронизировать Яндекс Формы",
      );
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        type="button"
        variant="secondary"
        className="px-3 py-1.5 text-sm"
        disabled={syncing}
        onClick={() => void handleSync()}
      >
        {syncing ? "Синхронизация…" : "Синхр. Яндекс"}
      </Button>
      {message ? (
        <p className="max-w-xs text-right font-onest text-[11px] text-slate-500">
          {message}
        </p>
      ) : null}
    </div>
  );
}
